import { render } from "./AffiliateChart2.vue?vue&type=template&id=62a71d94"
import script from "./AffiliateChart2.vue?vue&type=script&lang=js"
export * from "./AffiliateChart2.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__